export const containAtLeastEightCharacters = new RegExp(/^.{8,}$/);
export const containOneUppercase = new RegExp('.*[A-Z].*');
export const containOneLowercase = new RegExp('.*[a-z].*');
export const containOneNumber = new RegExp(/\d/);
export const containOneSepcicalCharacter = new RegExp(/[!""#$%&£'()*+,-./:;<=>?@[\]^_`{|}~\\\\]/);
export const containSpaceAtBeginningAndEnd = new RegExp(/^[^\s]+(\s+[^\s]+)*$/);
export const validTitle = new RegExp('^[A-Za-z0-9 ()_,.-]*$');
export const validTagImg = new RegExp('<img.+?src=.*?>');
export const validContactName = new RegExp('^[A-Za-z ]*$');